<template>
  <div>
    <v-text-field
      v-model="distributor.name"
      label="Distributor Name *"
      :rules="[validateNotEmpty]"
      data-testid="distributor-name"
    ></v-text-field>
    <v-text-field
      v-model="distributor.email"
      label="Billing email *"
      :rules="[validateNotEmpty, validateEmail]"
      data-testid="distributor-billing-email"
    >
    </v-text-field>
    <!--
      Owner onboarding fields. Shown ONLY on create (showOwnerFields):
      SA "Create Distributor" onboards the tenant Owner as part of create
      (create owner Account + set-password invite). The owner login email
      is SEPARATE from the distributor billing email above -- the two may
      differ. Card https://trello.com/c/fRuMEVvw.
    -->
    <template v-if="showOwnerFields">
      <v-text-field
        :model-value="ownerFirstName"
        @update:modelValue="$emit('update:ownerFirstName', $event)"
        label="Owner first name *"
        :rules="[validateNotEmpty]"
        data-testid="distributor-owner-first-name"
      ></v-text-field>
      <v-text-field
        :model-value="ownerLastName"
        @update:modelValue="$emit('update:ownerLastName', $event)"
        label="Owner last name *"
        :rules="[validateNotEmpty]"
        data-testid="distributor-owner-last-name"
      ></v-text-field>
      <v-text-field
        :model-value="ownerEmail"
        @update:modelValue="$emit('update:ownerEmail', $event)"
        label="Owner login email *"
        :rules="[validateNotEmpty, validateEmail]"
        data-testid="distributor-owner-email"
      ></v-text-field>
    </template>
    <v-text-field
      v-model="distributor.address"
      label="Physical address *"
      :rules="[validateNotEmpty]"
      data-testid="distributor-address"
      @update:modelValue="$emit('address-changed')"
    ></v-text-field>
    <div>
      <NexusStatesGrid
        :model-value="nexusStates"
        :disabled="nexusStatesLoading"
        @update:model-value="$emit('update:nexusStates', $event)"
      />
      <i>
        * Users are responsible for entering correct nexus state
        information and determining their nexus status for each state
      </i>
    </div>
  </div>
</template>

<script>
import rules from "@/mixins/rules";
import NexusStatesGrid from "@/pages/distributor/account/compliance/NexusStatesGrid.vue";

export default {
  name: "DistributorInfoForm",

  components: { NexusStatesGrid },

  mixins: [rules],

  props: {
    distributor: { type: Object, required: true },
    nexusStates: { type: Array, default: () => [] },
    nexusStatesLoading: { type: Boolean, default: false },
    // Owner onboarding fields render only on create. The parent gates this
    // (create vs edit) and owns the owner-field state via v-model bindings.
    showOwnerFields: { type: Boolean, default: false },
    ownerFirstName: { type: String, default: "" },
    ownerLastName: { type: String, default: "" },
    ownerEmail: { type: String, default: "" },
  },

  emits: [
    "address-changed",
    "update:nexusStates",
    "update:ownerFirstName",
    "update:ownerLastName",
    "update:ownerEmail",
  ],
};
</script>
